import { Pathnames } from 'next-intl/routing';

export const localePrefix = 'never';
export const defaultLocale = 'fr';
export const locales = [defaultLocale, 'en'] as const;

export enum PathEnum {
    Home = '/',
    Films = '/films/',
    ShortPrograms = '/short-programmes',
    GetInvolved = '/get-involved/',
    Checkout = '/checkout/',
    Tickets = '/tickets/',
    Partners = '/partners/',
    ProfileAccreditation = '/profile/accreditation/',
    SignUp = '/sign-up/',
    SignIn = '/sign-in/',
    Venues = '/tickets-and-venues/',
    Program = '/program/',
    Account = '/account/',
    MyTickets = '/account/my-tickets/',
    OrderHistory = '/account/order-history/',
    TravelInfo = '/account/travel-info/',
    Accreditation = '/account/accreditation/',
    NotFound = '/404/',
    Schedule = '/schedule/',
    InteractiveCatalog = '/interactive-catalogue/',
    ForgotPassword = '/forgot-password/',
    AcceptInvite = '/accept-invite/',
    Connexe = '/connexe/',
    Insights = '/insights/',
    About = '/about/',
    Awards = '/awards/',
    Jury = '/jury/',
    MySchedule = '/my-schedule/',
    Vote = '/vote/',
}

export const pathnames = {
    ...PathEnum,
} as Pathnames<typeof locales>;

export const donateLinkEn = 'https://donorbox.org/donate-now-to-encourage-lgbtq-storytelling';
export const donateLink =
    'https://donorbox.org/faire-un-don-et-encouragez-la-diffusion-d-histoires-lgbtq';
export const culturQueerDomain = 'https://image-nation.org/';
export const privacyPolicyLink = `/privacy-policy/`;
export const supportUsLink = `${culturQueerDomain}/support-us/`;
export const becomeVolunteerLink = `${culturQueerDomain}/become-a-volunteer/`;
export const submitFilmLink = 'https://image-nation.org/en/film-submission/';
export const submitFrFilmLink = 'https://image-nation.org/fr/film-submission/';
export const etaLink =
    'https://www.canada.ca/en/immigration-refugees-citizenship/services/visit-canada/eta/apply.html';

export type AppPathnames = keyof typeof pathnames;
